module.exports = __webpack_public_path__ + "static/media/MenuItemsCostPricing.856a53c7.svg";